const ArrowIcon = ({ width = 9, height = 18, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 9 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.747285 2.47955e-05C0.937285 2.47955e-05 1.12728 0.0700245 1.27728 0.220024L7.79729 6.74002C8.85729 7.80002 8.85729 9.54002 7.79729 10.6L1.27728 17.12C0.987285 17.41 0.507285 17.41 0.217285 17.12C-0.0727148 16.83 -0.0727148 16.35 0.217285 16.06L6.73728 9.54002C7.21728 9.06002 7.21728 8.28002 6.73728 7.80002L0.217285 1.28003C-0.0727148 0.990025 -0.0727148 0.510025 0.217285 0.220024C0.367285 0.0800247 0.557285 2.47955e-05 0.747285 2.47955e-05Z"
      fill="currentColor"
    />
  </svg>
);
export default ArrowIcon;
